import {Command} from '@application/command/command';
import {updateProductionSchedulePathsOfColoredYarnSets} from '@application/helper/production-schedule-builder/update-production-schedule-paths-of-colored-yarn-sets';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionSchedulePathsOfColoredYarnSet} from '@domain/production-schedule/production-schedule-paths-of-colored-yarn-set';
import {ParametersForRemovingProductionSchedulePath} from '@presentation/pages/texfab/production-schedule/add/plan/parameters-for-removing-production-schedule-path';
import {remove} from 'lodash-es';

export class RemoveProductionSchedulePathCommand implements Command<ParametersForRemovingProductionSchedulePath, ProductionSchedule> {
  public execute(commandArgs: ParametersForRemovingProductionSchedulePath): ProductionSchedule {
    const {productionSchedule, productionSchedulePathNumber, startDentOfColoredYarnSet} = commandArgs;

    const productionSchedulePathsOfColoredYarnSet: ProductionSchedulePathsOfColoredYarnSet = productionSchedule.getProductionSchedulePathsOfColoredYarnSetAtStartDent(startDentOfColoredYarnSet);

    remove(productionSchedulePathsOfColoredYarnSet.productionSchedulePaths, ['pathNumber', productionSchedulePathNumber]);
    return updateProductionSchedulePathsOfColoredYarnSets(productionSchedule);
  }
}
